export const downloadFile = (
  data: any,
  filename: string,
  mime = "application/octet-stream",
  newTab = false,
  sameWindow = false
) => {
  if (data) {
    let byteCharacters = atob(data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      let slice = byteCharacters.slice(offset, offset + 512);

      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    let blob = new Blob(byteArrays, { type: mime });
    let blobUrl = URL.createObjectURL(blob);

    if (newTab) {
      window.open(blobUrl, "_blank");
    } else if (sameWindow) {
      window.open(blobUrl, "_self");
    } else {
      let tempLink = document.createElement("a");
      tempLink.style.display = "none";
      tempLink.href = blobUrl;
      tempLink.setAttribute("download", filename);

      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking
      // is enabled.
      if (typeof tempLink.download === "undefined") {
        tempLink.setAttribute("target", "_blank");
      }

      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobUrl);
    }
  }
};

export function getContentTypeByMime(mime: string) {
  switch (mime) {
    case "txt":
      return "text/plain";
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case "word":
      return "application/msword";
    case "xls":
      return "application/excel";
    case "pdf":
      return "application/pdf";
    case "zip":
      return "application/zip";
  }
}
